import { Map } from 'immutable';

import Home from './scenes/Home';
import HomeDetails from './scenes/Home/details';
import HomeAdd from './scenes/Home/add';
import Box from './scenes/Box';
import Installer from './scenes/Installer';
import InstallerDetails from './scenes/Installer/details';
import InstallerAdd from './scenes/Installer/add';
import Products from './scenes/Products';
import Brands from './scenes/Brands';
import ProductAdd from './scenes/Products/add';
import ProductsDetails from './scenes/Products/details';
import Notification from './scenes/Notification';
import NotificationDetails from './scenes/Notification/details';
import NotificationAdd from './scenes/Notification/add';
import Issue from './scenes/Issues';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';
import User from './scenes/User';
import PushNotification from './scenes/PushNotification';
import PushNotificationDetails from './scenes/PushNotification/details';
import PushNotificationAdd from './scenes/PushNotification/add';

export default new Map({
    /** Home */
    '/home': {
        firstPage: true,
        must_logged: true,
        component: Home,
        right: 'homeList',
        children: new Map({
            /** Home detail */
            '/add': {
                index: 1,
                must_logged: true,
                component: HomeAdd,
                right: 'homeAdd'
            },
            /** Home detail */
            '/detail/:homeId': {
                must_logged: true,
                component: HomeDetails,
                right: 'homeDetails'
            }
        })
    },

    /** Users */
    '/users': {
        must_logged: true,
        component: User,
        right: 'userList'
    },
    /** Box */
    '/box': {
        must_logged: true,
        component: Box,
        right: 'boxList_fhe'
    },
    /** Brands */
    //'/brands': {
    //    must_logged: true,
    //    component: Brands,
    //},
    /** Installer */
    '/installer': {
        must_logged: true,
        component: Installer,
        right: 'installerList',
        children: new Map({
            /** Installer add */
            '/add': {
                index: 1,
                must_logged: true,
                component: InstallerAdd,
                right: 'installerAdd'
            },
            /** Installer detail */
            '/detail/:installerId': {
                must_logged: true,
                component: InstallerDetails,
                right: 'installerDetails'
            }
        })
    },

    /** Products */
    '/products': {
        must_logged: true,
        component: Products,
        right: 'productsList',
        children: new Map({
            /** Ajout d'un produit */
            '/add': {
                index: 1,
                must_logged: true,
                component: ProductAdd,
                right: 'addProduct'
            },
            /** Products details */
            '/:homeId/:productType/:productIdentifier': {
                must_logged: true,
                component: ProductsDetails,
                right: 'productsDetails'
            }
        })
    },

    /** Notifications */
    '/notifications': {
        must_logged: true,
        component: Notification,
        right: 'notificationList',
        children: new Map({
            /** Notifications add */
            '/add': {
                index: 1,
                must_logged: true,
                component: NotificationAdd,
                right: 'notificationAdd'
            },
            /** Notifications details */
            '/detail/:notificationId': {
                must_logged: true,
                component: NotificationDetails,
                right: 'notificationDetails'
            }
        })
    },

    '/issues': {
        must_logged: true,
        component: Issue,
        right: 'issuesList',
        children: new Map({
            '/:issueId/projects/:projectId': {
                must_logged: true,
                component: IssueDetails,
                right: 'issueDetails'
            },
            '/create': {
                must_logged: true,
                component: IssueCreate,
                right: 'issueCreate'
            }
        })
    },

    /** Notifications */
    '/push-notifications': {
        must_logged: true,
        component: PushNotification,
        right: 'pushNotificationList',
        children: new Map({
            /** Notifications add */
            '/add': {
                index: 1,
                must_logged: true,
                component: PushNotificationAdd,
                right: 'pushNotificationAdd'
            },
            /** Notifications details */
            '/detail/:pushNotificationId': {
                must_logged: true,
                component: PushNotificationDetails,
                right: 'pushNotificationDetails'
            }
        })
    }
});



// WEBPACK FOOTER //
// ./environments/fhe/routes.js